export default "__VITE_ASSET__BUnZwnP7__"